import React from 'react'
import { PropTypes } from 'prop-types'

const PrimaryTitle = props => {
  return (
    <div className="text-center">
      <div className="title-primary-wrapper">
        <h1 className="title primary" role="heading" aria-level="1">
          {props.title}
        </h1>
      </div>
    </div>
  );
}

PrimaryTitle.propTypes = {
  title: PropTypes.string
}

export default PrimaryTitle
